import {
  blue,
  gray,
  green,
  orange,
  pink,
  purple,
  red,
  yellow,
} from './palette';
import { Collection, Token } from './types';

// Uncategorized colors
export const shadow = new Token('#000D331a', 'color-shadow');
export const focus = new Token(blue.get(800), 'color-focus');

export const surface = new Collection({
  default: new Collection({
    [Collection.Default]: new Token(gray.get(0), 'color-surface-default'),
    hover: new Token(gray.get(100), 'color-surface-default-hover'),
    active: new Token(gray.get(200), 'color-surface-default-active'),
  }),

  inverse: new Token(gray.get(950), 'color-surface-inverse'),

  primary: new Collection({
    [Collection.Default]: new Token(blue.get(700), 'color-surface-primary'),
    hover: new Token(blue.get(800), 'color-surface-primary-hover'),
    active: new Token(blue.get(900), 'color-surface-primary-active'),
  }),

  primaryLight: new Collection({
    [Collection.Default]: new Token(
      blue.get(200),
      'color-surface-primary-light',
    ),
    hover: new Token(blue.get(300), 'color-surface-primary-light-hover'),
    active: new Token(blue.get(400), 'color-surface-primary-light-active'),
  }),

  secondary: new Collection({
    [Collection.Default]: new Token(gray.get(100), 'color-surface-secondary'),
    hover: new Token(gray.get(200), 'color-surface-secondary-hover'),
    active: new Token(gray.get(300), 'color-surface-secondary-active'),
  }),

  positive: new Collection({
    [Collection.Default]: new Token(green.get(700), 'color-surface-positive'),
    hover: new Token(green.get(800), 'color-surface-positive-hover'),

    light: new Collection({
      [Collection.Default]: new Token(
        green.get(200),
        'color-surface-positive-light',
      ),
      hover: new Token(green.get(300), 'color-surface-positive-light-hover'),
    }),
  }),

  warning: new Collection({
    [Collection.Default]: new Token(orange.get(700), 'color-surface-warning'),
    hover: new Token(orange.get(800), 'color-surface-warning-hover'),

    light: new Collection({
      [Collection.Default]: new Token(
        orange.get(200),
        'color-surface-warning-light',
      ),
      hover: new Token(orange.get(300), 'color-surface-warning-light-hover'),
    }),
  }),

  negative: new Collection({
    [Collection.Default]: new Token(red.get(700), 'color-surface-negative'),
    hover: new Token(red.get(800), 'color-surface-negative-hover'),

    light: new Collection({
      [Collection.Default]: new Token(
        red.get(200),
        'color-surface-negative-light',
      ),
      hover: new Token(red.get(300), 'color-surface-negative-light-hover'),
    }),
  }),

  state: new Collection({
    disabled: new Token(gray.get(100), 'color-surface-state-disabled'),

    selected: new Collection({
      [Collection.Default]: new Token(
        blue.get(700),
        'color-surface-state-selected',
      ),
      hover: new Token(blue.get(800), 'color-surface-state-selected-hover'),
      active: new Token(blue.get(900), 'color-surface-state-selected-active'),

      light: new Collection({
        [Collection.Default]: new Token(
          blue.get(200),
          'color-surface-state-selected-light',
        ),
        hover: new Token(
          blue.get(300),
          'color-surface-state-selected-light-hover',
        ),
        active: new Token(
          blue.get(400),
          'color-surface-state-selected-light-active',
        ),
      }),
    }),
  }),
});

export const content = new Collection({
  default: new Token(gray.get(950), 'color-content-default'),
  subtle: new Token(gray.get(800), 'color-content-subtle'),
  muted: new Token(gray.get(600), 'color-content-muted'),

  onInverse: new Token(gray.get(0), 'color-content-on-inverse'),
  onPrimary: new Token(gray.get(0), 'color-content-on-primary'),
  onPrimaryLight: new Token(gray.get(700), 'color-content-on-primary-light'),
  onPositive: new Token(gray.get(0), 'color-content-on-positive'),
  onWarning: new Token(gray.get(0), 'color-content-on-warning'),
  onNegative: new Token(gray.get(0), 'color-content-on-negative'),

  primary: new Collection({
    [Collection.Default]: new Token(blue.get(700), 'color-content-primary'),
    subtle: new Token(blue.get(500), 'color-content-primary-subtle'),
    strong: new Token(blue.get(900), 'color-content-primary-strong'),
  }),

  positive: new Collection({
    [Collection.Default]: new Token(green.get(700), 'color-content-positive'),
    subtle: new Token(green.get(500), 'color-content-positive-subtle'),
    strong: new Token(green.get(950), 'color-content-positive-strong'),
  }),
  warning: new Collection({
    [Collection.Default]: new Token(orange.get(700), 'color-content-warning'),
    subtle: new Token(orange.get(500), 'color-content-warning-subtle'),
    strong: new Token(orange.get(950), 'color-content-warning-strong'),
  }),

  negative: new Collection({
    [Collection.Default]: new Token(red.get(700), 'color-content-negative'),
    subtle: new Token(red.get(500), 'color-content-negative-subtle'),
    strong: new Token(red.get(950), 'color-content-negative-strong'),
  }),

  state: new Collection({
    focused: new Token(blue.get(700), 'color-content-state-focused'),
    disabled: new Token(gray.get(500), 'color-content-state-disabled'),
  }),
});

export const border = new Collection({
  default: new Collection({
    [Collection.Default]: new Token(gray.get(400), 'color-border-default'),
    hover: new Token(gray.get(500), 'color-border-default-hover'),
  }),

  inverse: new Token(gray.get(0), 'color-border-inverse'),

  subtle: new Collection({
    [Collection.Default]: new Token(gray.get(300), 'color-border-subtle'),
    hover: new Token(gray.get(400), 'color-border-subtle-hover'),
  }),

  primary: new Collection({
    [Collection.Default]: new Token(blue.get(400), 'color-border-primary'),
    hover: new Token(blue.get(500), 'color-border-primary-hover'),

    strong: new Collection({
      [Collection.Default]: new Token(
        blue.get(700),
        'color-border-primary-strong',
      ),
      hover: new Token(blue.get(800), 'color-border-primary-strong-hover'),
    }),
  }),

  positive: new Collection({
    [Collection.Default]: new Token(green.get(400), 'color-border-positive'),
    hover: new Token(green.get(500), 'color-border-positive-hover'),

    strong: new Collection({
      [Collection.Default]: new Token(
        green.get(700),
        'color-border-positive-strong',
      ),
      hover: new Token(green.get(800), 'color-border-positive-strong-hover'),
    }),
  }),

  warning: new Collection({
    [Collection.Default]: new Token(yellow.get(600), 'color-border-warning'),
    hover: new Token(yellow.get(700), 'color-border-warning-hover'),

    strong: new Collection({
      [Collection.Default]: new Token(
        yellow.get(700),
        'color-border-warning-strong',
      ),
      hover: new Token(yellow.get(800), 'color-border-warning-strong-hover'),
    }),
  }),

  negative: new Collection({
    [Collection.Default]: new Token(red.get(400), 'color-border-negative'),
    hover: new Token(red.get(500), 'color-border-negative-hover'),

    strong: new Collection({
      [Collection.Default]: new Token(
        red.get(700),
        'color-border-negative-strong',
      ),
      hover: new Token(red.get(800), 'color-border-negative-strong-hover'),
    }),
  }),

  state: new Collection({
    selected: new Token(blue.get(700), 'color-border-state-selected'),
    disabled: new Token(gray.get(200), 'color-border-state-disabled'),
    focused: new Token(blue.get(600), 'color-border-state-focused'),
  }),
});

export const alpha = new Collection({
  5: new Token('#1a1a1a0d', 'color-alpha-5'),
  10: new Token('#1a1a1a1a', 'color-alpha-10'),
  20: new Token('#1a1a1a33', 'color-alpha-20'),
  30: new Token('#1a1a1a4d', 'color-alpha-30'),
  40: new Token('#1a1a1a66', 'color-alpha-40'),
  50: new Token('#1a1a1a80', 'color-alpha-50'),
});

export const avatar = new Collection({
  solid: new Collection({
    blue: new Collection({
      [Collection.Default]: new Token(blue.get(700), 'color-avatar-solid-blue'),
      text: new Token(gray.get(0), 'color-avatar-solid-blue-text'),
    }),
    gray: new Collection({
      [Collection.Default]: new Token(gray.get(700), 'color-avatar-solid-gray'),
      text: new Token(gray.get(0), 'color-avatar-solid-gray-text'),
    }),
    yellow: new Collection({
      [Collection.Default]: new Token(
        yellow.get(700),
        'color-avatar-solid-yellow',
      ),
      text: new Token(gray.get(0), 'color-avatar-solid-yellow-text'),
    }),
    orange: new Collection({
      [Collection.Default]: new Token(
        orange.get(700),
        'color-avatar-solid-orange',
      ),
      text: new Token(gray.get(0), 'color-avatar-solid-orange-text'),
    }),
    green: new Collection({
      [Collection.Default]: new Token(
        green.get(700),
        'color-avatar-solid-green',
      ),
      text: new Token(gray.get(0), 'color-avatar-solid-green-text'),
    }),
    purple: new Collection({
      [Collection.Default]: new Token(
        purple.get(700),
        'color-avatar-solid-purple',
      ),
      text: new Token(gray.get(0), 'color-avatar-solid-purple-text'),
    }),
    pink: new Collection({
      [Collection.Default]: new Token(pink.get(700), 'color-avatar-solid-pink'),
      text: new Token(gray.get(0), 'color-avatar-solid-pink-text'),
    }),
    red: new Collection({
      [Collection.Default]: new Token(red.get(700), 'color-avatar-solid-red'),
      text: new Token(gray.get(0), 'color-avatar-solid-red-text'),
    }),
    empty: new Collection({
      [Collection.Default]: new Token(
        gray.get(200),
        'color-avatar-solid-empty',
      ),
      text: new Token(gray.get(950), 'color-avatar-solid-empty-text'),
    }),
  }),
});

export const button = new Collection({
  primary: new Collection({
    bg: new Collection({
      [Collection.Default]: new Token(blue.get(700), 'color-button-primary-bg'),
      hover: new Token(blue.get(800), 'color-button-primary-hover-bg'),
      active: new Token(blue.get(900), 'color-button-primary-active-bg'),
      pressed: new Token(blue.get(900), 'color-button-primary-pressed-bg'),
      disabled: new Token(
        surface.get('state').get('disabled'),
        'color-button-primary-disabled-bg',
      ),
    }),

    text: new Collection({
      [Collection.Default]: new Token(gray.get(0), 'color-button-primary-text'),
      disabled: new Token(
        content.get('state').get('disabled'),
        'color-button-primary-text-disabled',
      ),
    }),
  }),

  softPrimary: new Collection({
    bg: new Collection({
      [Collection.Default]: new Token(
        blue.get(200),
        'color-button-soft-primary-bg',
      ),
      hover: new Token(blue.get(300), 'color-button-soft-primary-bg-hover'),
      active: new Token(blue.get(400), 'color-button-soft-primary-bg-active'),
      pressed: new Token(blue.get(400), 'color-button-soft-primary-bg-pressed'),
      disabled: new Token(
        surface.get('state').get('disabled'),
        'color-button-soft-primary-bg-disabled',
      ),
    }),

    text: new Collection({
      [Collection.Default]: new Token(
        blue.get(700),
        'color-button-soft-primary-text',
      ),
      disabled: new Token(
        content.get('state').get('disabled'),
        'color-button-soft-primary-text-disabled',
      ),
    }),
  }),

  softNeutral: new Collection({
    bg: new Collection({
      [Collection.Default]: new Token(
        gray.get(100),
        'color-button-soft-neutral-bg',
      ),
      legacyBase: new Token(
        gray.get(200),
        'color-button-soft-neutral-bg-legacy-base',
      ),
      hover: new Token(gray.get(200), 'color-button-soft-neutral-bg-hover'),
      legacyHover: new Token(
        gray.get(300),
        'color-button-soft-neutral-bg-legacy-hover',
      ),
      active: new Token(gray.get(200), 'color-button-soft-neutral-bg-active'),
      legacyActive: new Token(
        gray.get(400),
        'color-button-soft-neutral-bg-legacy-active',
      ),
      pressed: new Token(gray.get(200), 'color-button-soft-neutral-bg-pressed'),
      legacyPressed: new Token(
        gray.get(400),
        'color-button-soft-neutral-bg-legacy-pressed',
      ),
      disabled: new Token(
        surface.get('state').get('disabled'),
        'color-button-soft-neutral-bg-disabled',
      ),
    }),

    text: new Collection({
      [Collection.Default]: new Token(
        gray.get(950),
        'color-button-soft-neutral-text',
      ),
      disabled: new Token(
        content.get('state').get('disabled'),
        'color-button-soft-neutral-text-disabled',
      ),
    }),
  }),

  outlinePrimary: new Collection({
    bg: new Collection({
      [Collection.Default]: new Token(
        'transparent',
        'color-button-outline-primary-bg',
      ),
      legacyBase: new Token(
        gray.get(0),
        'color-button-outline-primary-bg-legacy-base',
      ),
      hover: new Token(blue.get(100), 'color-button-outline-primary-bg-hover'),
      active: new Token(
        blue.get(200),
        'color-button-outline-primary-bg-active',
      ),
      pressed: new Token(
        blue.get(200),
        'color-button-outline-primary-bg-pressed',
      ),
      disabled: new Token(
        surface.get('state').get('disabled'),
        'color-button-outline-primary-bg-disabled',
      ),
    }),

    text: new Collection({
      [Collection.Default]: new Token(
        gray.get(950),
        'color-button-outline-primary-text',
      ),
      disabled: new Token(
        content.get('state').get('disabled'),
        'color-button-outline-primary-text-disabled',
      ),
    }),

    border: new Collection({
      [Collection.Default]: new Token(
        blue.get(700),
        'color-button-outline-primary-outline',
      ),
      disabled: new Token(
        border.get('state').get('disabled'),
        'color-button-outline-primary-outline-disabled',
      ),
    }),
  }),

  outlineNeutral: new Collection({
    bg: new Collection({
      [Collection.Default]: new Token(
        'transparent',
        'color-button-outline-neutral-bg',
      ),
      legacyBase: new Token(
        gray.get(0),
        'color-button-outline-neutral-bg-legacy-base',
      ),
      hover: new Token(gray.get(100), 'color-button-outline-neutral-bg-hover'),
      active: new Token(
        gray.get(200),
        'color-button-outline-neutral-bg-active',
      ),
      pressed: new Token(
        gray.get(200),
        'color-button-outline-neutral-bg-pressed',
      ),
      disabled: new Token(
        surface.get('state').get('disabled'),
        'color-button-outline-neutral-bg-disabled',
      ),
    }),

    text: new Collection({
      [Collection.Default]: new Token(
        gray.get(950),
        'color-button-outline-neutral-text',
      ),
      disabled: new Token(
        content.get('state').get('disabled'),
        'color-button-outline-neutral-text-disabled',
      ),
    }),

    border: new Collection({
      [Collection.Default]: new Token(
        gray.get(400),
        'color-button-outline-neutral-outline',
      ),
      disabled: new Token(
        border.get('state').get('disabled'),
        'color-button-outline-neutral-outline-disabled',
      ),
    }),
  }),

  ghost: new Collection({
    bg: new Collection({
      [Collection.Default]: new Token('transparent', 'color-button-ghost-bg'),
      hover: new Token(gray.get(100), 'color-button-ghost-bg-hover'),
      active: new Token(gray.get(200), 'color-button-ghost-bg-active'),
      pressed: new Token(gray.get(200), 'color-button-ghost-bg-pressed'),
      disabled: new Token(
        surface.get('state').get('disabled'),
        'color-button-ghost-bg-disabled',
      ),
    }),

    text: new Collection({
      [Collection.Default]: new Token(
        gray.get(950),
        'color-button-subtle-text',
      ),
      disabled: new Token(
        content.get('state').get('disabled'),
        'color-button-subtle-text-disabled',
      ),
    }),
  }),

  negative: new Collection({
    bg: new Collection({
      [Collection.Default]: new Token(red.get(700), 'color-button-negative-bg'),
      hover: new Token(red.get(800), 'color-button-negative-bg-hover'),
      active: new Token(red.get(900), 'color-button-negative-bg-active'),
      pressed: new Token(red.get(900), 'color-button-negative-bg-pressed'),
      disabled: new Token(
        surface.get('state').get('disabled'),
        'color-button-negative-bg-disabled',
      ),
    }),

    text: new Collection({
      [Collection.Default]: new Token(
        gray.get(0),
        'color-button-negative-text',
      ),
      disabled: new Token(
        content.get('state').get('disabled'),
        'color-button-negative-text-disabled',
      ),
    }),
  }),
});

export const tag = new Collection({
  gray: new Collection({
    [Collection.Default]: new Token(gray.get(200), 'color-tag-gray'),
    hover: new Token(gray.get(300), 'color-tag-gray-hover'),
    active: new Token(gray.get(400), 'color-tag-gray-active'),
  }),
  blue: new Collection({
    [Collection.Default]: new Token(blue.get(200), 'color-tag-blue'),
    hover: new Token(blue.get(300), 'color-tag-blue-hover'),
    active: new Token(blue.get(400), 'color-tag-blue-active'),
  }),
  yellow: new Collection({
    [Collection.Default]: new Token(yellow.get(200), 'color-tag-yellow'),
    hover: new Token(yellow.get(300), 'color-tag-yellow-hover'),
    active: new Token(yellow.get(400), 'color-tag-yellow-active'),
  }),
  orange: new Collection({
    [Collection.Default]: new Token(orange.get(200), 'color-tag-orange'),
    hover: new Token(orange.get(300), 'color-tag-orange-hover'),
    active: new Token(orange.get(400), 'color-tag-orange-active'),
  }),
  green: new Collection({
    [Collection.Default]: new Token(green.get(200), 'color-tag-green'),
    hover: new Token(green.get(300), 'color-tag-green-hover'),
    active: new Token(green.get(400), 'color-tag-green-active'),
  }),
  darkGreen: new Collection({
    [Collection.Default]: new Token(green.get(900), 'color-tag-dark-green'),
    hover: new Token(green.get(900), 'color-tag-dark-green-hover'),
    active: new Token(green.get(900), 'color-tag-dark-green-active'),
  }),
  purple: new Collection({
    [Collection.Default]: new Token(purple.get(200), 'color-tag-purple'),
    hover: new Token(purple.get(300), 'color-tag-purple-hover'),
    active: new Token(purple.get(400), 'color-tag-purple-active'),
  }),
  pink: new Collection({
    [Collection.Default]: new Token(pink.get(200), 'color-tag-pink'),
    hover: new Token(pink.get(300), 'color-tag-pink-hover'),
    active: new Token(pink.get(400), 'color-tag-pink-active'),
  }),
  red: new Collection({
    [Collection.Default]: new Token(red.get(200), 'color-tag-red'),
    hover: new Token(red.get(300), 'color-tag-red-hover'),
    active: new Token(red.get(400), 'color-tag-red-active'),
  }),
});

export const overlay = new Collection({
  default: new Token('#0000001a', 'color-overlay-default'),
  dark: new Token('#0000004d', 'color-overlay-dark'),
  darker: new Token('#00000080', 'color-overlay-darker'),
});
